import {helpers} from "@vuelidate/validators";

export const pattern = (param) =>
    value => !helpers.req(value) || param.test(value);